import React from "react";

const Error403Component = (props, context) => {
    return (
        <>
            <div className="row justify-content-center h-100 align-items-center pt-5">
                <div className="col-md-5">
                    <div className="form-input-content text-center error-page">
                        <h1 className="error-text  font-weight-bold">403</h1>
                        <h4><i className="fa fa-times-circle text-danger"></i> Forbidden Error!</h4>
                        <p>You do not have permission to view this resource.</p>
                        <div>
                            <a className="btn btn-primary" href="#/dashboard">Back to Home</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Error403Component;